import { render } from "./AddHsCodeModal.vue?vue&type=template&id=e4a88cbc&ts=true"
import script from "./AddHsCodeModal.vue?vue&type=script&lang=ts"
export * from "./AddHsCodeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__